import React, { useState } from "react";
import { Star } from "lucide-react";

/**
 * Estrelas de 1 a 5. Se `onChange` for passado, é interativo; senão é read-only.
 * value: número 0..5 (0 = sem nota)
 */
export function StarRating({ value = 0, onChange, size = 20, readOnly = false, testid }) {
  const [hover, setHover] = useState(0);
  const active = hover || value || 0;
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= active;
        const common = {
          size,
          className: filled ? "text-amber-400" : "text-slate-300",
          fill: filled ? "currentColor" : "none",
        };
        if (readOnly || !onChange) return <Star key={n} {...common} />;
        return (
          <button
            key={n}
            type="button"
            data-testid={testid ? `${testid}-star-${n}` : undefined}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(value === n ? 0 : n)}
            className="p-0.5 leading-none hover:scale-110 transition-transform"
            title={`${n} estrela${n > 1 ? "s" : ""}`}
          >
            <Star {...common} />
          </button>
        );
      })}
    </div>
  );
}

/**
 * Grade de modalidades com estrelas. `categories` = [{id,name}], `values` = {id:1..5}.
 * onChange(catId, star) atualiza a nota.
 */
export function CategoryStars({ categories, values = {}, onChange, readOnly = false, testid = "cat-stars" }) {
  if (!categories || categories.length === 0) {
    return <div className="text-xs text-slate-400">Nenhuma modalidade cadastrada.</div>;
  }
  return (
    <div className="space-y-2" data-testid={testid}>
      {categories.map((c) => (
        <div key={c.id} className="flex items-center justify-between gap-3">
          <span className="text-sm text-slate-600">{c.name}</span>
          <StarRating
            value={values[c.id] || 0}
            onChange={readOnly ? undefined : (n) => onChange(c.id, n)}
            readOnly={readOnly}
            size={18}
            testid={`${testid}-${c.id}`}
          />
        </div>
      ))}
    </div>
  );
}
